import { gql } from '@apollo/client';
import PRODUCT_FRAGMENT from './product';
import PRODUCT_CURRICULUM_FRAGMENT from './product-curriculum';

const USER_LICENSE_USAGE_FRAGMENT = gql`
  fragment BaseUserLicenseUsage on UserLicenseUsage {
    productId
    productCurriculumId
    assignedCount
    active
    trial
    product {
      ...BaseProduct
    }
    productCurriculum {
      ...BaseProductCurriculum
    }
  }
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_CURRICULUM_FRAGMENT}
`;

export default USER_LICENSE_USAGE_FRAGMENT;
